<template>
	<div class="list_board">
		<table class="tbl_board_g">
			<caption>게시글 목록</caption>
			<thead>
			<tr>
				<th scope="col" class="td_board" v-if="!isSearch"><span class="screen_out">리스트 번호</span></th>
				<th scope="col" class="td_title t_c">제목</th>
				<th scope="col" class="td_writer" v-if="showsAuthor">글쓴이</th>
				<th scope="col" class="td_date">작성일</th>
				<th scope="col" class="td_recommend" v-if="!isSearch">추천</th>
				<th scope="col" class="td_look">조회</th>
			</tr>
			</thead>
			<tbody id="more-article-list">
			<template v-for="article in articles" v-bind="article">
				<restricted-common-article-item v-if="isRestricted(article)" v-bind="article"/>
				<common-article-item v-else v-bind="article"/>
			</template>
			</tbody>
		</table>
	</div>
</template>

<script>
import RestrictedCommonArticleItem from './RestrictedCommonArticleItem.vue';
import CommonArticleItem from './CommonArticleItem.vue';
import {mapState, mapGetters} from 'vuex';

export default {
	components: {
		RestrictedCommonArticleItem, CommonArticleItem
	},
	computed: {
		...mapState(['articles', 'isAnonymous']),
		...mapGetters(['isSearch', 'isArticle']),
		showsAuthor() {
			return !this.isArticle || !this.isAnonymous;
		}
	},
	methods: {
		isRestricted(article) {
			return !!article.vldstatus;
		}
	}
}
</script>
